export const getPageFrames = (page: any) => {
  const frames = page.children.filter((node: any) => node.type === 'FRAME');

  return frames;
};

export const getPageOptions = (pages: any) =>
  pages.map((page: any) => ({ label: page.name, value: page.id }));

export const isTaskFrame = (frameName: any) => /Task\s[0-9]+$/g.test(frameName);

export const isInitialTaskFrame = (frameName: any) =>
  /Initial State$/g.test(frameName);

const _checkFrameCorrect = ({
  frame,
  designType,
}: {
  frame: any;
  designType: any;
}) => {
  switch (designType) {
    case 'DESIGN': {
      return isInitialTaskFrame(frame.name) || isTaskFrame(frame.name);
    }
    case 'PROTOTYPE': {
      return true;
    }
    default: {
      return false;
    }
  }
};

const _formatFrames = ({
  frames,
  designType,
}: {
  frames: any;
  designType: any;
}) =>
  frames.map((frame: any) => ({
    id: frame.id,
    name: frame.name,
    correct: _checkFrameCorrect({ frame, designType }),
  }));

const _getPageDesignType = (page: any) => {
  const type = page.name.split(':')[0];

  if (type === 'Design') {
    return 'DESIGN';
  }

  if (type === 'Prototype') {
    return 'PROTOTYPE';
  }

  return null;
};

export const formatPages = (pages: any) =>
  pages.map((page: any) => ({
    id: page.id,
    name: page.name,
    frames: _formatFrames({
      frames: page.children,
      designType: _getPageDesignType(page),
    }),
    loaded: false,
  }));
